// 社媒流视频 poster 懒加载：data-sf-poster 进入视口附近时才写入 poster。
// 弹窗内视频 display:none 时不会相交，弹窗打开后才加载；Splide loop 克隆出的 slide 由 MutationObserver 补挂。
(function () {
  if (window.__kikLazyPosterInit) return;
  window.__kikLazyPosterInit = true;

  var SELECTOR = 'video[data-sf-poster]';

  function apply(video) {
    var src = video.getAttribute('data-sf-poster');
    if (!src) return;
    video.setAttribute('poster', src);
    video.removeAttribute('data-sf-poster');
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach(apply);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      apply(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  function observeIn(root) {
    if (root.matches && root.matches(SELECTOR)) observer.observe(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(function (v) { observer.observe(v); });
  }

  observeIn(document);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) observeIn(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
